import LogoBackgroundSilhouette from '@/components/LogoBackgroundSilhouette';
import { fadeInUp } from '@/constants/motions';
import ButtonLink from '@/ui/ButtonLink';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

export default function MissionVisionBlock({ data }) {
  const safe = data || { items: [] };
  // const items = [
  //   {
  //     icon: <Icon height="80" icon="fluent:target-arrow-24-filled" />,
  //     title: 'Mission Statement',
  //     content:
  //       'The CEAD group of companies, consisting of Engineering, Construction and Manpower, strives to provide the best professional contracting services for local and regional Mining, Oil & Gas, Power, Water and Petro-Chemical companies adhering to strict international.',
  //   },
  //   {
  //     icon: <Icon height="80" icon="fluent:people-24-filled" />,
  //     title: 'Our Team',
  //     content:
  //       'Our success is based on our excellent employees. We recruit and retain the right people by providing excellent benefits, a good life/work balance and the encouragement to develop on both a personal as well as a professional level.',
  //   },
  //   {
  //     icon: <Icon height="80" icon="el:eye-open" />,
  //     title: 'Vision Statement',
  //     content:
  //       'We want to provide the best contracting services for the Mining, Oil & Gas, Power, Water and Petro-Chemical companies in Suriname and the region. We want to be part of an integrated project development including Engineering, Construction and Maintenance.',
  //   },
  // ];

  return (
    <section className="relative  bg-primary-700 py-16 lg:mt-64 lg:pt-16">
      <div className="absolute -top-32 left-0 hidden h-full w-full skew-y-6 bg-primary-700 lg:block"></div>
      <div className="absolute left-0 hidden opacity-10 lg:-top-16 lg:block lg:h-[610px] lg:w-[1000px] xl:-top-40 xl:w-[1419px]">
        <LogoBackgroundSilhouette />
      </div>
      <div className="container-screen relative">
        <motion.div
          className="flex flex-wrap justify-center gap-y-12"
          initial="hidden"
          transition={{
            ...fadeInUp.transition,
            duration: 0.8,
            staggerChildren: 0.4,
          }}
          variants={fadeInUp}
          viewport={fadeInUp.viewport}
          whileInView="visible"
        >
          {(safe.items || []).map(({ icon, title, text }, i) => (
            <motion.div
              key={i}
              className="flex w-full flex-col items-center px-8 text-center text-white md:w-1/2 lg:w-1/3"
              variants={fadeInUp}
            >
              <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-full bg-gradient-to-b from-primary-500 to-primary-600">
                <Icon height="80" icon={icon} />
              </div>
              <h4 className="mt-4 text-lg font-medium">{title}</h4>
              <p className="mt-3 font-light">{text}</p>
            </motion.div>
          ))}
        </motion.div>
        <motion.div
          className="mx-auto mt-12 max-w-max"
          initial="hidden"
          transition={fadeInUp.transition}
          variants={fadeInUp}
          viewport={fadeInUp.viewport}
          whileInView="visible"
        >
          <ButtonLink
            color="inverted"
            href="/about"
            icon={<Icon height="24" icon="fluent:chevron-circle-right-16-filled" />}
          >
            Read More
          </ButtonLink>
        </motion.div>
      </div>
    </section>
  );
}
